<ng-container *transloco="let tr; prefix: 'webkassaCashboxes'; scope: 'webkassa-cashboxes'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('orgAuth.title')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('orgAuth.subTitle')}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <hx-org-select [(ngModel)]="filter.orgId" (ngModelChange)="applyFilters()"></hx-org-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="org-title" [nzSortOrder]="columnSortOrderMap.get('org-title') || null" [nzSortFn]="true"
          [nzSortPriority]="1">{{tr('orgAuth.column.organization')}}</th>
      <th nzColumnKey="login">{{tr('orgAuth.column.login')}}</th>
      <th nzColumnKey="password">{{tr('orgAuth.column.password')}}</th>
      <th nzColumnKey="token">{{tr('orgAuth.column.token')}}</th>
      <th nzColumnKey="tokenDate">{{tr('orgAuth.column.tokenDate')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle' : 'minus-circle'"
             [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.organizationTitle | uiLabel }}
      </td>
      <td>{{ data.login }}</td>
      <td>{{ data.password }}</td>
      <td>{{ data.token }}</td>
      <td>{{ data.tokenDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
